<template lang="pug">
  div
    label
      input.switch(
        type='checkbox'
        @change='change'
        :disabled="disabled"
        v-model="currentValue"
        :class="{'switch-animbg': transition==='normal', 'switch-anim': transition==='anim'}"
      )
      span.label(@click='click') {{label}}
</template>

<script>
export default {
  props: {
    transition: String,
    text: {
      type: Object,
      default() {
        return {
          disable: '',
          active: ''
        }
      }
    },
    value: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    change() {
      this.$emit('change', this.currentValue)
    },
    click() {
      this.currentValue = !this.currentValue
      this.change()
    }
  },
  computed: {
    label() {
      return this.value ? this.text.active : this.text.disable
    },
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.borderRadius(@radius:20px) {
  border-radius: @radius;
  border-top-left-radius: @radius;
  border-top-right-radius: @radius;
  border-bottom-left-radius: @radius;
  border-bottom-right-radius: @radius;
}

@duration: 0.4s;
@checkedColor: @main_color;
@borderColor: @bd_color;
@backgroundColor: #fff;
@switchWidth: 2rem;
@switchBarWitch: 0.74rem;

label {
  position: relative;
  .label {
    position: absolute;
    top: -0.26rem;
  }
  .switch + .label {
    left: 1rem;
    color: @checkedColor;
  }
  .switch:checked + .label {
    left: 0.4rem;
    color: #fff;
  }
}

.switch {
  .borderRadius;
  width: @switchWidth;
  height: 0.8rem;
  position: relative;
  border: 1px solid @checkedColor;
  background-color: @backgroundColor;
  box-shadow: @borderColor 0 0 0 0 inset;
  background-clip: content-box;
  display: inline-block;
  -webkit-appearance: none;
  user-select: none;
  outline: none;
  &:before {
    .borderRadius;
    content: '';
    width: @switchBarWitch;
    height: @switchBarWitch;
    position: absolute;
    top: 0px;
    left: 0;
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
  }
  &:checked {
    border-color: @checkedColor;
    box-shadow: @checkedColor 0 0 0 16px inset;
    background-color: @checkedColor;
    &:before {
      left: @switchWidth - @switchBarWitch - 0.05rem;
    }
  }
  &.switch-animbg {
    transition: background-color ease @duration;
    &:before {
      transition: left 0.3s;
    }
    &:checked {
      box-shadow: @borderColor 0 0 0 0 inset;
      background-color: @checkedColor;
      transition: border-color @duration, background-color ease @duration;
      &:before {
        transition: left 0.3s;
      }
    }
  }
  &.switch-anim {
    transition: border cubic-bezier(0, 0, 0, 1) @duration, box-shadow cubic-bezier(0, 0, 0, 1) @duration;
    &:before {
      transition: left 0.3s;
    }
    &:checked {
      box-shadow: @checkedColor 0 0 0 16px inset;
      background-color: @checkedColor;
      transition: border ease @duration, box-shadow ease @duration, background-color ease @duration*3;
      &:before {
        transition: left 0.3s;
      }
    }
  }
}
</style>
